// Kiln data adapter: normalize existing firing structures into kiln events.

function estimateLoad(firing = {}, productsById = {}) {
  if (Number.isFinite(firing.estimatedVolumeLitres)) return firing.estimatedVolumeLitres;
  if (Number.isFinite(firing.estimatedItems) && firing.estimatedItems > 0) {
    return firing.estimatedItems * 1.5; // simple fallback: 1.5L per item
  }
  // If firing references products, sum known volumes
  if (Array.isArray(firing.productIds)) {
    return firing.productIds.reduce((sum, pid) => {
      const p = productsById[pid];
      const vol = Number(p?.volumeLitres || p?.volume || 0);
      return sum + (Number.isFinite(vol) ? vol : 0);
    }, 0);
  }
  return 0;
}

export function mapToKilnSchedule(firings = [], productsById = {}) {
  return (firings || []).map((f) => ({
    id: f.id,
    type: f.type || "bisque",
    start: f.startTime ? new Date(f.startTime) : (f.start ? new Date(f.start) : null),
    end: f.endTime ? new Date(f.endTime) : (f.end ? new Date(f.end) : null),
    status: f.status || "planned",
    kilnId: f.kilnId || "default",
    estimatedLoadLitres: estimateLoad(f, productsById),
  }));
}
